import { render, staticRenderFns } from "./centerS.vue?vue&type=template&id=2585c1e2&scoped=true&"
import script from "./centerS.vue?vue&type=script&lang=js&"
export * from "./centerS.vue?vue&type=script&lang=js&"
import style0 from "./centerS.vue?vue&type=style&index=0&id=2585c1e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2585c1e2",
  null
  
)

export default component.exports